<template>
    <div>
        <!--        <Icon class="icon" name="dns" v-if="icon"/>-->
        <span class="title">{{title}}</span>
        <span class="value">{{value}}</span>
    </div>
</template>

<script>
    import Icon from './Icon';

    export default {
        name: 'UserSectionStat',
        components: {Icon},
        props: {
            // icon: String,
            title: String,
            value: String
        }
    };
</script>

<style scoped>
    .title {
        text-align: left;
        display: block;
        font-size: .85em;
        opacity: .7;
        margin: 2px;
        font-weight: normal;
    }

    .value {
        text-align: left;
        font-size: 1.1em;
        opacity: 1;
        margin: 2px;
        font-weight: bolder;
    }
</style>
